module.exports = __webpack_public_path__ + "static/media/costpic2@2x.7443327d.png";